import { createFileRoute } from '@tanstack/react-router';
import AdBluePercOnline from '../../../components/Graphs/AdBluePerc';

export const Route = createFileRoute('/_authenticated/graphs/ad-blue-percent/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'widget.adblueLevel.valueName.long',
        params: { valueType: '%' },
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AdBluePercentGraphRoute,
});

function AdBluePercentGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <AdBluePercOnline vehicleId={Number(vehicleId)} isPage />;
}
